import React from 'react';
import './css/about.css'; // Make sure to create this CSS file for styling
import Footer from './footer';

const About = () => {
    return (
        <>
        <section className="about-section">
            <div className="about-text">
                <h2>عن غادة السعداوي</h2>
                <p>
                    أنا غادة السعداوي، أخصائية نفسية أطفال متخصصة، أعمل بشغف لمساعدة الأطفال وعائلاتهم في التغلب على التحديات العاطفية والنفسية. مع سنوات من الخبرة في هذا المجال، أستخدم مجموعة متنوعة من التقنيات العلاجية المخصصة لتلبية الاحتياجات الفريدة لكل طفل.
                </p>
                <p>
                    تتمثل مهمتي في إنشاء بيئة داعمة حيث يمكن للأطفال التعبير عن أنفسهم بحرية والعمل على التغلب على العقبات التي تواجههم. من خلال عملي، أهدف إلى تمكين كل من الأطفال وعائلاتهم لتحقيق الصحة النفسية والرفاهية الإيجابية.
                </p>
            </div>
            <div className="about-video">
                <iframe 
                    src="https://www.youtube.com/embed/your_video_id" 
                    frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowFullScreen
                ></iframe>
            </div>
        </section>
        </>
    );
}

export default About;
